import { Component } from "../../../modules/Core/Component";
import templateDefault from "../../templates/default/widgets/drawers/sub-menu-drawer";

export default class SubMenuDrawer extends Component {
  id = "sub-menu-drawer";

  template = templateDefault;

  toggle(menu) {
    if (menu !== undefined) this.setData({ "default.menu": menu });
    this.toggleData("default.opened", {
      defaultValue: true,
    });
  }

  toggleMenuDrawer() {
    this.getComponents()
      .findById("menu-drawer")
      .forEach((drawer) => {
        drawer.toggle();
      });
  }

  getMainMenu() {
    const menuDrawer = this.getComponents().findById("menu-drawer").first();
    return menuDrawer ? menuDrawer.getData("default.mainMenu", []) : [];
  }
}
